import React from 'react';
import {Flex} from "antd";

interface StatusBarItemProps {
  number: number,
  text: string,
  disabled?: boolean,
}

export default function PageLinkItem({number, text, disabled = false}: StatusBarItemProps) {
  return (
   <>
     <Flex className={'status-bar__number ' + (disabled ? 'disabled' : '')} align={'center'} justify={'center'}>
       <span className={'status-bar__text ' + (disabled ? 'disabled' : '')}>{number}</span>
     </Flex>
     <div className={'status-bar__text ' + (disabled ? 'disabled' : '')}>{text}</div>
   </>
  )
}
